export default "__VITE_ASSET__CWXNCesu__"